import { render, staticRenderFns } from "./XtendConfigModal.vue?vue&type=template&id=76a4ad43&"
import script from "./XtendConfigModal.vue?vue&type=script&lang=js&"
export * from "./XtendConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports